import { LS_KEYS } from '@constants/local-store';
import { getStorage } from '@utils/local-store';
import axios from 'axios';
import { performResponseData } from '../utils/api';

const userAppApi = axios.create({
  baseURL: `${process.env.REACT_APP_USER_APP_SERVICE_URL}${process.env.REACT_APP_USER_APP_SERVICE_NAME}`,
  headers: {
    // 'Content-Type': 'application/x-www-form-urlencoded',
    // 'Access-Control-Allow-Origin': '*',
    // 'Access-Control-Allow-Headers':
    //   'Origin, X-Requested-With, Content-Type, Accept',
    'Content-Type': 'application/json',
    Accept: 'application/json, text/plain, */*',
  },
});

const onResponseSuccess = (response: any) => {
  const { data } = response;

  return Promise.resolve({
    ...response,
    data: performResponseData(data),
  });
};

userAppApi.interceptors.request.use(function (config) {
  const token = getStorage(LS_KEYS.AUTH_TOKEN);

  config.headers.Authorization = 'Bearer ' + token;

  return config;
});

userAppApi.interceptors.response.use(onResponseSuccess);

export default userAppApi;
